import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { AutopayActivatorModule } from './autopay-activator/autopay-activator.module';
import { AutopayComponent } from './autopay.component';
import { CountdownModule } from '../../../shared/countdown/countdown.module';
import { LegfiCurrencyPipe } from '../../../../pipes/format/legfi-currency.pipe';
import { LegfiCurrencyPipeModule } from '../../../../pipes/format/legfi-currency.module';
import { LegfiDatePipeModule } from '../../../../pipes/format/legfi-date.module';
import { LegfiDatePipe } from '../../../../pipes/format/legfi-date.pipe';
import { MembersService } from '../../../../services/members/members.service';
import { AutopayDisableConfirmationModule } from './autopay-disable-confirmation/autopay-disable-confirmation.module';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        AutopayActivatorModule,
        AutopayDisableConfirmationModule,
        CountdownModule,
        LegfiCurrencyPipeModule,
        LegfiDatePipeModule,
    ],
    declarations: [AutopayComponent],
    exports: [AutopayComponent],
    providers: [
        // Pipes
        LegfiCurrencyPipe,
        LegfiDatePipe,
        // Services
        MembersService,
    ],
})
export class AutopayModule
{
}
